import { CLEAR_VIDEO_STORIES_MEDIA, SET_VIDEO_STORIES_INDEX, SET_VIDEO_STORIES_MEDIA_EVENTS, SET_VIDEO_STORIES_TEMPLATE_QUEUE, SET_VIDEO_STORY_PLAYERS, } from '../actions/VideoStory';
import { generateTemplateId } from '../middlewares/SkyfireTemplateMiddleware';
const initialState = {
    metadata: {
        videoStoryTemplateQueue: [],
        currentTemplateIndex: 0,
    },
    events: {
        onCreated: [],
        onNavigateToNext: [],
        onNavigateToPrevious: [],
        onClose: [],
        onVideoStoryTemplateQueueRequired: [],
    },
    videoStoryPlayers: [],
};
const reducer = {
    [SET_VIDEO_STORIES_TEMPLATE_QUEUE]: function setVideoStoriesTemplateQueue(state, action) {
        const updatedVideoStoryTemplateQueue = action.payload.videoStoryTemplateQueue.map((template) => (Object.assign(Object.assign({}, template), { id: generateTemplateId(template) })));
        return Object.assign(Object.assign({}, state), { metadata: Object.assign(Object.assign({}, state.metadata), { videoStoryTemplateQueue: updatedVideoStoryTemplateQueue }) });
    },
    [SET_VIDEO_STORIES_INDEX]: (state, action) => (Object.assign(Object.assign({}, state), { metadata: Object.assign(Object.assign({}, state.metadata), { currentTemplateIndex: action.payload.currentTemplateIndex }) })),
    [SET_VIDEO_STORIES_MEDIA_EVENTS]: (state, action) => (Object.assign(Object.assign({}, state), { events: action.payload })),
    [CLEAR_VIDEO_STORIES_MEDIA]: (state, action) => initialState,
    [SET_VIDEO_STORY_PLAYERS]: (state, action) => (Object.assign(Object.assign({}, state), { videoStoryPlayers: action.payload.videoStoryPlayers })),
};
export function VideoStoriesMediaReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    return state;
}
